import { StripHtml } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import { IconDispatcher } from "shared/Icons";
import InsightType from "shared/ui-basics/ui-components/InsightType";
import styled, { css } from "styled-components/macro";

interface InsightPickListCardProps {
	insight: any;
}

const InsightPickListCard: React.FC<InsightPickListCardProps> = ({ insight}) => {
	const { t } = useTranslation();

	const name = insight?.name ? insight.name : t("NEW_INSIGHT_NAME");
	const description = StripHtml(insight?.description || "");

	return (
		<Container>
			<Header>
				<TitleContainer>
					<LogoContainer>
						<Logo>{IconDispatcher("gem")}</Logo>
					</LogoContainer>
					<Title>{name}</Title>
				</TitleContainer>
				<InsightTypeContainer>
					<InsightType typeId={insight?.typeId} />
				</InsightTypeContainer>
			</Header>
			{description && <Description>{description}</Description>}
		</Container>
	);
};

InsightPickListCard.displayName = "InsightPickListCard";
export default InsightPickListCard;

const Container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

const TitleContainer = styled.div`
	position: relative;
`;

const Title = styled.div`
	color: #262626;
	font-size: 14px;
	font-weight: 600;
	text-indent: 2rem;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	overflow: hidden;
`;

const LogoContainer = styled.div`
	position: absolute;
	width: 24px;
	height: 24px;
	.svg {
		width: 24px;
		height: 24px;
	}
`;

const Logo = styled.div`
	width: 100%;
	height: 100%;
	border: 1px solid #262626;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
`;

const Description = styled.div`
	width: 100%;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	color: #262626;
	font-style: normal;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
`;

const InsightTypeContainer = styled.div`
	display: flex;
	align-self: flex-start;
`;
